import { NextResponse } from 'next/server';

import { trackRudderstackEvent } from '../libs/rudderstack';

export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  trackRudderstackEvent(eventName, properties);
}

export function setConsentModeCookie(response: NextResponse, consentMode: string) {
  response.cookies.set('consent_mode', consentMode, {
    path: '/',
    sameSite: 'lax',
    // Don't set httpOnly — client JS needs to read this
  });
}

export function getConsentMode(): 'opt-in' | 'opt-out' {
  if (typeof window === 'undefined') {
    return 'opt-in';
  }

  const match = window.document.cookie.split('; ').find((row) => row.startsWith('consent_mode='));

  return (match?.split('=')[1] as 'opt-in' | 'opt-out') ?? 'opt-in';
}
